import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Input, Switch } from "antd";
import { observer } from "mobx-react";
import { Fragment, useState } from "react";
import { List } from "react-window";
import { AnalyseItem } from "./analyseItem.js";
import { useStores } from "../store/stores.js";
import { __ } from "../utils/i18n.js";
function AnalyseItemRow({ index, attachments, onClick, style }) {
    return /*#__PURE__*/ _jsx(AnalyseItem, {
        style: style,
        attachment: attachments[index],
        onClick: onClick
    }, attachments[index].id);
}
const AnalyseItems = observer(({ attachments, onClick, fallback, buttonRight })=>{
    const { attachmentsStore } = useStores();
    const { regenerateFailures } = attachmentsStore;
    const all = attachmentsStore[attachments];
    const [term, setTerm] = useState("");
    const [showErrors, setShowErrors] = useState(false);
    // Collect data and apply filters
    let useAttachments = all;
    if (term) {
        useAttachments = useAttachments.filter(({ filename })=>filename.indexOf(term) > -1);
    }
    if (showErrors) {
        useAttachments = useAttachments.filter(({ error })=>error?.length > 0);
    }
    if (!all.length) {
        return fallback || null;
    }
    function renderList(height) {
        return /*#__PURE__*/ _jsx(List, {
            rowComponent: AnalyseItemRow,
            rowCount: useAttachments.length,
            rowHeight: 40,
            rowProps: {
                attachments: useAttachments,
                onClick
            },
            className: "rtg-thumbnails-list",
            style: {
                height,
                width: "100%"
            }
        });
    }
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "wp-clearfix",
                style: {
                    margin: "10px 0"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "alignright",
                        style: {
                            marginLeft: 5,
                            marginTop: 4
                        },
                        title: __("Show only failed regenerations"),
                        children: [
                            regenerateFailures > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Switch, {
                                        defaultChecked: showErrors,
                                        onChange: (checked)=>setShowErrors(checked)
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ _jsx(ExclamationCircleOutlined, {}),
                                    " ",
                                    regenerateFailures
                                ]
                            }),
                            buttonRight
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Input.Search, {
                        placeholder: __("Search by filename..."),
                        onSearch: (value)=>setTerm(value),
                        style: {
                            width: 200
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "rtg-grow",
                children: window.Playwright ? renderList(300) : renderList(300)
            })
        ]
    });
});
export { AnalyseItems };
